<template>
  <b-container>
    <h1>{{ $t("vehicle.create") }}</h1>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />

    <b-row class="mb-3 ml-0">
      <router-link :to="getUrlBackToList">
        <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
      </router-link>
    </b-row>
    <b-row>
      <b-col sm="12" md="6" lg="6">
        <vehicle-registration-crud
          ref="crudData"
          :model="model"
          :modelstate="modelstate"
          :allType="allType"
        ></vehicle-registration-crud>
      </b-col>
    </b-row>

    <!-- {{ model }} -->
    <b-button @click="save()" type="submit" :disabled="submitted">
      {{ $t("geral.save") }}
    </b-button>
  </b-container>
</template>
<script>
export default {
  name: "VehicleCreate",
  components: {
    VehicleRegistrationCrud: () =>
      import(
        "@/components_rms/vehicle/Registration/VehicleRegistrationCrud.vue"
      ),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue")
  },
  computed: {
    getUrlBackToList() {
      return `../vehicleRegistration/list`;
    }
  },
  data() {
    return {
      alert: {
        error: "",
        success: this.$t("vehicle.createSuccess")
      },
      submitted: false,
      model: {
        active: true,
        plate: "",
        vehicleTypeId: null,
        documentExpiration: "",
        km: 0.0,
        hour: 0,
        height: 0.0,
        width: 0.0,
        weight: 0.0,
        length: 0.0,
        vehicleModelId: null,
        costCenterId: null,
        companyBranchId: null
      },
      modelstate: {},
      allType: []
    };
  },
  created() {
    this.getAllVehicleType();
  },
  methods: {
    save() {
      this.submitted = true;
      this.$apiVehicle
        .post("/vehicleRegistration/create/", this.model)
        .then(response => {
          this.modelstate = {};
          this.cleanModel();
          this.submitted = false;
          this.$forceUpdate();
          this.$refs.alert.show();
        })
        .catch(error => {
          this.submitted = false;

          console.log(error);
          console.log(error.response);
          console.log(error.errorCode);

          switch (error.response.status) {
            case 401:
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
              break;
            case 400:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = error.response.data.errors;
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
            default:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = {};
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
          }
        });
    },
    getAllVehicleType() {
      this.$apiVehicle.get("/vehicleType/listAllType/").then(response => {
        this.allType = response.data;
        this.allType.forEach(type => {
          this.vehicleTypeOpt.push({
            value: type.id,
            text: type.name
          });
        });
      });
    },
    cleanModel() {
      this.model.plate = "";
      this.model.vehicleTypeId = null;
      this.model.documentExpiration = "";
      this.model.km = 0.0;
      this.model.height = 0.0;
      this.model.width = 0.0;
      this.model.weight = 0.0;
      this.model.length = 0.0;
      this.model.vehicleModelId = null;
      this.model.costCenterId = null;
      this.model.companyBranchId = null;
    }
  }
};
</script>
